<template>
  <el-dialog
    title="重新进厂"
    :visible.sync="visible"
    width="600px"
    :close-on-click-modal="false"
    @close="onReset"
  >
    <div class="py-2">确认重新进厂吗？系统将关闭该记录，关闭该记录后，司机可重新过磅！</div>
    <el-form ref="form" :model="form" :rules="rules" label-width="6em">
      <el-form-item label="关闭原因" prop="close_reason">
        <el-input placeholder="请输入重新进厂原因" type="textarea" v-model="form.close_reason"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button size="small" type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      form: {},
      rules: {
        close_reason: [
          { required: true, message: "请输入关闭原因", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    onConfirm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await this.$common.http({
              url: "/api/queue/admin/again_booking_pound",
              data: this.form
            });
            this.$emit("ok");
            this.visible = false;
          } catch (error) {}
        }
      });
    },
    onOpen(row) {
      this.form.id = row.id;
      this.visible = true;
    },
    onReset() {
      this.form = {};
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 0 15px !important;
}
</style>
